export default __webpack_public_path__ + "static/media/348.66c1ead5.png";